import { combineReducers } from 'redux';
import type { AnyAction } from 'redux';
import * as Types from '../types';
import { DefaultState } from '@portal/portal-core';

// UserInvites resolves from an untyped .js sibling -> typed as any at the boundary.
import { UserInvites } from './user-invites';

function userRoles(state: string[] = [], action: AnyAction): string[] {
  switch (action.type) {
    case Types.USER_ROLES_LOADED:
      return Array.isArray(action.payload?.roles) ? action.payload.roles : [];
    case DefaultState.DEFAULT_STATE:
      return [];
    default:
      return state;
  }
}

const CombinedReducer = combineReducers({ userInvites: UserInvites, userRoles });
// Continue to export each individual reducer to also provide la carte menu.
// Consumer can then import either combined (UserClientReducers.CombinedReducer)
// or individual (UserClientReducers.UserInvites).
export { UserInvites, userRoles, CombinedReducer };
